<template>
  <el-select
      v-model="selectedValue"
      @change="emitChange()"
      :loading="loading"
      ref="generic-select"
      :no-match-text="noMatchingText"
      filterable
  >
    <el-option
        v-for="item in list"
        :key="item[valueField]"
        :label="capitalize(item[labelField])"
        :value="item[valueField]"
        :disabled="item.disabled"
    ></el-option>
  </el-select>
</template>

<script>
import selectService from '@/api/selectService';

export default {
  name: 'SelectList',
  props: {
    value: {
      default: null
    },
    /* End Point Url to search data. */
    url: {
      type: String,
      default: null
    },
    /* The attribute name of item that must be show in the options of the list. */
    labelField: {
      type: String,
      default: null
    },
    /* The attribute name of item that must be updated the model. */
    valueField: {
      type: String,
      default: null
    },
    /* The parameters that will be send with the url. */
    getParams: {
      type: Object,
      default: null
    },
    /* usually the select will be loaded with values that are not used,
     so the current value will not appear in the list and therefore we must add it. */
    currentValueObject: {
      type: Object,
      default: null
    },
    noMatchingText: {
      type: String,
      default: null
    },
    defaultAll: {
      type: Boolean,
      default: false
    },
    /* Default auto search is in true, for some components if we need additional data in getParams
    that is not ready on mounted then we need to put autosearch in false until we will have getParams,
    the get params changes performs an autosearch.
    */
    autoSearch: {
      type: Boolean,
      default: true
    },
    orderBy: {
      type: String,
      default: null
    },
    upperCaseLabel: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    getParams() {
      if (!this.autoSearch) {
        this.search();
      }
    }
  },
  data() {
    return {
      selectedValue: this.value,
      list: [],
      loading: false
    };
  },
  mounted() {
    if (this.defaultAll) {
      this.list = [{ description: 'All', id: null }];
    } else {
      this.list = [{}];
    }
    if (this.autoSearch) {
      this.search();
    }
  },
  methods: {
    emitChange() {
      this.$emit('update:value', this.selectedValue);
      this.$emit('change', this.selectedValue);
    },
    search() {
      this.list = [this.list[0]];
      if (this.currentValueObject && this.currentValueObject.trailer_id) {
        this.list.push(this.currentValueObject);
      }
      this.loading = true;
      selectService.getList(this.url, this.getParams).then((response) => {
        if (response instanceof Array) {
          this.list = [...this.list, ...response];
          this.loading = false;
          this.checkSelectedValueAfterSearch();
        } else if (response.data && response.data instanceof Array) {
          this.list = [...this.list, ...response.data];
          this.loading = false;
          this.checkSelectedValueAfterSearch();
        }
        this.orderList();
      }).catch(() => {
        this.loading = false;
      });
    },
    checkSelectedValueAfterSearch() {
      // We check if the selected value is on list, otherwise we clear it.
      if (this.selectedValue && !this.list.some(item => (this.selectedValue === item[this.valueField]))) {
        this.selectedValue = null;
        this.emitChange();
      }
    },
    clearLocalModel() {
      this.selectedValue = null;
    },
    orderList() {
      if (this.orderBy) {
        this.list.sort((a, b) => {
          if (this.capitalize(a[this.orderBy]) < this.capitalize(b[this.orderBy])) return -1;
          if (this.capitalize(a[this.orderBy]) > this.capitalize(b[this.orderBy])) return 1;
          return 0;
        });
      }
    },
    capitalize(text) {
      if (!this.upperCaseLabel) {
        return text;
      }
      if (typeof text !== 'string') {
        return text;
      }
      return text.toUpperCase();
    }
  }
};
</script>
